// Angular
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';

// Models
import { MetaData } from 'src/app/platform/models/utils';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { PlatformService } from 'src/app/platform/services/platform.service';
import { ProductsService } from 'src/app/modules/products/products.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';


@Component({
  selector: 'app-products-add',
  templateUrl: './products-add.component.html',
  styleUrls: ['./products-add.component.scss']
})
export class ProductsAddComponent implements OnInit {
  public formData: FormGroup = new FormGroup({
      product: new FormControl({disabled: false}, [Validators.required]),
      plan: new FormControl('', [Validators.required]),
  });
  public plansData: Array<MetaData> = [];

  constructor(
    public dialog: MatDialogRef<ProductsAddComponent>,
    private uiService: UiService,
    private platformService: PlatformService,
    private productService: ProductsService,
    private proceduresService: ProceduresService,
  ) {  }

  ngOnInit(): void {
    this.uiService.showSpinner(true);

    this.productService.plansGet().then((success) => {
      this.uiService.showSpinner(false);
      this.plansData = success.result;
    }).catch((error) => {
      this.uiService.showSpinner(false);
      this.dialog.close();
      this.uiService.dialogShow('Ups!', 'No es posible adquirir productos en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }

  onCancel(): void {
    this.dialog.close();
  }

  onSubmit(): void {
    if (this.formData.valid) {
      this.uiService.showSpinner(true);

      this.productService.contractsAdd(this.formData.get('plan')?.value).then((result) => {
        if (result.status) {
          this.dialog.close();

          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Solicitud iniciada', 'Tu solicitud fue enviada, a la brevedad un asistente revisará tu pedido. Tu número de gestión es: <p><h1>' + result.result.id + '</h1>', 'success');

          this.proceduresService.proceduresUpdate(true);
        }
        else {
          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar solicitar el producto. Por favor intenta nuevamente.', 'error');
        }
      }, (error) => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible solicitar el producto en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
      });
    } else {
      this.formData.markAllAsTouched();
      this.uiService.showSnackBar('Algunos datos no están completos');
    }
  }

  formHasError(formcontrol: string, data: string): any {
    const fields: any = {
      plan: {
        required:  'Seleccione un plan comercial'
      }
    };

    return this.platformService.formHasError(this.formData, fields, formcontrol, data);
  }
}
